import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Tabs, TabList, Tab, TabPanel } from 'react-tabs';
import { Container, Row, Col } from 'reactstrap';
import { Link } from 'react-router-dom';
import 'react-tabs/style/react-tabs.css';
import Box, { HStack, VStack } from '@chakra-ui/react';
import ActionModal from '../shared/ActivationModal';
import Page from '../shared/Page';
import withEulaRestrictions from '../license/withEulaRestrictions';
import withRoleRestrictions from '../shared/withRoleRestrictions';
import { getBreadCrumbs } from '../../utils/breadCrumbs';
import styles from './styles.scss';
import Button from '../shared/Button';
import Modal from '../shared/Modal';
import RequiredAsterisk from '../shared/RequiredAsterisk';
import SaveButton from '../shared/SaveButton';
import { notifyInfo, notifyError } from '../../utils/notifier';
import { Pressure, Radon, Temperature, getMDCAverageRadonValue } from '../../utils/uom';
import { IMPERIAL, METRIC, DEFAULT_UOM, SYSTEMS_OF_MEASURE } from '../../constants/uom';

import { fetchReportOptionsFromTest } from '../../actions/companies/apiRequests';
import QCTestInfo from '../testDetails/QCTestInfo';

// Test Detail
import ExportTestCard from '../testDetails/ExportTestCard';
import QCToggle from '../testDetails/QCToggle';
import TestImages from '../testDetails/TestImages';
import FloorPlan from '../testDetails/FloorPlan';
import IsnIntegration from '../testDetails/IsnIntegration';
import IsnPostReport from '../testDetails/IsnPostReport';
import StateSpecificNotes from '../shared/StateSpecificNotes';
import SelectLayout from './SelectLayout';

// Test Result
import TestResultsTable from '../testDetails/TestResultsTable';

import { postReport } from '../../actions/isn/apiRequests';

// Actions
import {
  getDeviceTypes,
  updatePhoto,
  deletePhoto,
  updateFloorPlan,
  updateAllFloorPlans,
  deleteFloorPlan,
  deleteAllFloorPlans,
  syncWithIsn,
  fetchPhoto,
  deleteTest,
} from '../../actions/tests/apiRequests';

import { fetchLayout, fetchAllVisibleLayouts } from '../../actions/layout/apiRequests';
import { fetchDynamicTestDataById, updateDinamicTest } from '../../actions/dinamicTest/apiRequests';
import { DynamicRenderControls, REQUIRED_FIELD_NAMES } from '../../utils/fieldManagement';
import { fetchCompany } from '../../actions/companies/apiRequests';
import { fromIsn } from '../../utils/convertToDynamicValues';
import {
  checkLegacy,
  getCopyAndReplaceItemByIndex,
  getFieldEditMode,
  getFormat,
  getSameFreeIndexInArrays,
  onLastCalibrationChange,
} from './utils';
import { TEST_TYPES, getDinamycTestName, QC_DEVICE_TYPE_OPTIONS } from '../../constants/test';
import { OFFICIAL_REPORT, QC_LAYOUT, UNOFFICIAL_REPORT } from '../../constants/reportLayouts';
import * as ReportLayoutDropdown from '../../utils/reportLayoutDropdown';

const legacyDevices = ['RS', 'SN'];

const tabsImages = { DETAILS: '/location.png', CONDITIONS: '/cloud.png', OBSERVATIONS: '/eye.png' };

const propTypes = {
  match: PropTypes.object,
  location: PropTypes.object,
  history: PropTypes.object,
  user: PropTypes.object,
};

class DynamicTestDetailsPage extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      testId: props.match.params.id,
      layoutId: null,
      layout: null,
      layouts: null,
      deviceTypes: {},
      values: {},
      errors: {},
      validationErrors: {},
      testImagesBase64: [null, null],
      images: [null, null],
      deleteImages: [false, false],
      floorPlanFiles: [null, null],
      floorPlanDisplayUrls: [null, null],
      deleteFloorPlanFiles: [false, false],
      fileUploadError: false,
      floorPlanUploadError: false,
      isFloorPlanDelete: false,
      isDataCollecting: false,
      isnDataPosting: false,
      isnDataPostedResult: null,
      saving: false,
      intervalReport: null,
      company: {},
      qcErrors: {},
      showValidationErrors: true,
      filesMaxIsReachedError: false,
      floorPlanMaxIsReachedError: false,
      reportLayout: null,
      reportLayoutOptions: [],
      showDeleteModal: false,
      includeUncertaintyCalculation: false
    };
    this.onFieldChange = this.onFieldChange.bind(this);
    this.onFieldValidate = this.onFieldValidate.bind(this);
    this.onSave = this.onSave.bind(this);
    this.onLoadImage = this.onLoadImage.bind(this);
    this.onClearImage = this.onClearImage.bind(this);
    this.onLoadFloorPlan = this.onLoadFloorPlan.bind(this);
    this.onClearFloorPlan = this.onClearFloorPlan.bind(this);
    this.onIsnPostData = this.onIsnPostData.bind(this);
    this.onIsnGetData = this.onIsnGetData.bind(this);
    this.onChangeReportLayout = this.onChangeReportLayout.bind(this);
    this.renderQcTestInfo = this.renderQcTestInfo.bind(this);
    this.onQcFieldValidate = this.onQcFieldValidate.bind(this);
    this.onQcFieldChange = this.onQcFieldChange.bind(this);
    this.onSwitchUom = this.onSwitchUom.bind(this);
    this.showImageErrorWindow = this.showImageErrorWindow.bind(this);
    this.showFloorPlanErrorWindow = this.showFloorPlanErrorWindow.bind(this);
    this.hideErrorWindow = this.hideErrorWindow.bind(this);
    this.isSaveDisabled = this.isSaveDisabled.bind(this);
    this.renderExports = this.renderExports.bind(this);
    this.toggleDeleteModal = this.toggleDeleteModal.bind(this);

    this.maxImages = 2;
  }

  get editMode() {
    const { location = {} } = this.props;
    return location.state && location.state.editMode;
  }

  get saveButton() {
    const { saving } = this.state;
    return <SaveButton key="save" onClick={this.onSave} loading={saving} disabled={saving || this.isSaveDisabled()} />;
  }

  get cancelButton() {
    return (
      <Link
        to={{
          pathname: `/tests/`,
        }}
        key="cancel"
      >
        <Button>Cancel</Button>
      </Link>
    );
  }

  get deleteButton() {
    return (
      <Button kind="danger" className="mr-5" onClick={() => this.toggleDeleteModal()}>
        Delete
      </Button>
    );
  }

  toggleDeleteModal() {
    this.setState((prevState) => ({
      showDeleteModal: !prevState.showDeleteModal,
    }));
  }

  isSaveDisabled() {
    const {
      errors,
      qcErrors,
      validationErrors,
      values: { TestType: testType },
    } = this.state;

    const requiredFieldErrors = REQUIRED_FIELD_NAMES.map((fieldName) => errors[fieldName]).filter(Boolean);
    const invalidFieldErrors = Object.values(validationErrors).filter(Boolean);
    let qcFieldErrors = [];

    if (testType === TEST_TYPES.qc || testType === TEST_TYPES.dinamicQc) {
      qcFieldErrors = Object.values(qcErrors).filter(Boolean);
    }

    return requiredFieldErrors.length > 0 || invalidFieldErrors > 0 || qcFieldErrors.length > 0;
  }

  componentDidMount() {
    const { testId } = this.state;
    window.scrollTo(0, 0);

    fetchDynamicTestDataById(testId).then((data) => {
      this.setState(
        {
          values: data.values,
          layoutId: data.layoutId,
          intervalReport: data.intervalReport,
          floorPlanDisplayUrls: [data.values.FloorPlanDisplayUrl, data.values.FloorPlanDisplayUrl2],
        },
        () => {
          Promise.all([this.fetchTestReportOptions(), fetchLayout(this.state.layoutId)]).then(
            ([{defaultReportLayout, includeUncertaintyCalculation}, layout]) => {
              const values = data.values;
              var isTestValid = values['IstestValid'];
              if (isTestValid === 'No' && values['InvalidReportReason'] === undefined) {
                isTestValid = undefined;
              }
              const layoutType = layout.type;

              let finalDefaultReport =
                defaultReportLayout === OFFICIAL_REPORT && isTestValid === 'No'
                  ? UNOFFICIAL_REPORT
                  : defaultReportLayout;

              const reportLayoutOptions = ReportLayoutDropdown.getDynamicTestOptions(layoutType, {
                isTestValid,
                isQcTest: values.TestType === TEST_TYPES.qc || values.TestType === TEST_TYPES.dinamicQc,
              });
              const reportLayout = ReportLayoutDropdown.getValue(reportLayoutOptions, finalDefaultReport);

              this.setState({
                layout,
                reportLayout,
                reportLayoutOptions,
                includeUncertaintyCalculation
              });
            },
          );

          fetchCompany(data.values.CompanyId).then((company) => {
            this.setState({ company: company });
          });

          fetchPhoto(data.values.Id).then((photos) => {
            this.setState({ testImagesBase64: [photos.photo1Base64, photos.photo2Base64] });
          });
        },
      );
    });

    fetchAllVisibleLayouts().then((data) => {
      this.setState({ layouts: data });
    });

    getDeviceTypes().then((deviceTypes) => {
      this.setState({
        deviceTypes,
      });
    });
  }

  fetchTestReportOptions() {
    const { testId } = this.state;

    return fetchReportOptionsFromTest(testId).then(({ defaultLayout, includeUncertaintyCalculation }) => ({
      defaultReportLayout: defaultLayout, includeUncertaintyCalculation
    }));
  }

  onSave() {
    const { layoutId, testId, values } = this.state;

    this.setState({ saving: true });

    return updateDinamicTest(layoutId, testId, values, true)
      .then(() => this.uploadAttachment())
      .then(() => notifyInfo())
      .catch(() => notifyError())
      .finally(() => this.setState({ saving: false }));
  }

  async uploadFilesSequentially(newFiles) {
    const {
      values: { Id },
    } = this.state;

    for (const [index, file] of newFiles.entries()) {
      if (file) await updateFloorPlan(Id, index + 1, file);
    }
  }

  uploadAttachment() {
    const {
      values: { Id },
      images,
      floorPlanFiles,
      deleteImages,
      deleteFloorPlanFiles,
    } = this.state;

    const promises = [];

    if (deleteImages.includes(true)) {
      deleteImages.forEach(
        (item, index) =>
          item && promises.push(deletePhoto(Id, index + 1).then(() => this.setState({ deleteImages: [false, false] }))),
      );
    }

    if (deleteFloorPlanFiles.every((isDeleting) => isDeleting)) {
      promises.push(deleteAllFloorPlans(Id, floorPlanFiles));
    } else {
      deleteFloorPlanFiles.forEach(
        (isDeleting, index) =>
          isDeleting &&
          promises.push(
            deleteFloorPlan(Id, index + 1).then(() =>
              this.setState({
                deleteFloorPlanFiles: getCopyAndReplaceItemByIndex(index, deleteFloorPlanFiles, false),
              }),
            ),
          ),
      );
    }

    if (images.some((image) => image !== null)) {
      images.forEach((image, index) => image && promises.push(updatePhoto(Id, index + 1, image)));
    }

    if (floorPlanFiles.some((file) => file !== null)) promises.push(this.uploadFilesSequentially(floorPlanFiles));

    return Promise.all(promises);
  }

  onIsnGetData() {
    const { testId } = this.state;
    this.setState((prevState) => ({
      isDataCollecting: !prevState.isDataCollecting,
    }));

    syncWithIsn(testId)
      .then((data) => {
        this.setState((prevState) => ({
          isDataCollecting: !prevState.isDataCollecting,
          values: {
            ...prevState.values,
            ...fromIsn(data),
          },
        }));
        notifyInfo();
      })
      .catch((error) => {
        this.setState((prevState) => ({
          isDataCollecting: !prevState.isDataCollecting,
        }));

        if (error.message) {
          notifyError(error.message);
        } else {
          notifyError(
            'There was an error retrieving your test data from your ISN account. Please retry later or contact your system administrator for assistance.',
          );
        }
      });
  }

  getBreadCrumbs(title) {
    const { pathname } = this.props.location;
    return getBreadCrumbs(title, pathname, []);
  }

  onFieldChange(name, value) {
    this.setState((prevState) => ({
      ...prevState.test,
      values: {
        ...prevState.values,
        [name]: value,
        ...(name === 'LastCalibration' && onLastCalibrationChange(value)),
      },
    }));
  }

  onFieldValidate(name, error, isValidationError) {
    this.setState((prevState) => ({
      ...prevState.test,
      errors: {
        ...prevState.errors,
        [name]: error,
      },
      validationErrors: {
        ...prevState.validationErrors,
        [name]: isValidationError,
      },
    }));
  }

  onLoadImage(files) {
    const { images, testImagesBase64 } = this.state;
    const filesMaxIsReachedError =
      images.filter(Boolean).length === this.maxImages || testImagesBase64.filter(Boolean).length === this.maxImages;

    this.setState({
      filesMaxIsReachedError,
      images: images.map((image, index) => (!testImagesBase64[index] && !image ? files.shift() : image)),
    });
  }

  onClearImage(imageIndexToDelete) {
    const { images, deleteImages, testImagesBase64 } = this.state;

    this.setState({
      images: images.map((image, index) => (index === imageIndexToDelete ? null : image)),
      testImagesBase64: testImagesBase64.map((image, index) => (index === imageIndexToDelete ? null : image)),
      deleteImages: deleteImages.map((item, index) => (index === imageIndexToDelete ? true : item)),
    });
  }

  onLoadFloorPlan(file) {
    const { floorPlanFiles, floorPlanDisplayUrls } = this.state;
    const freeIndex = getSameFreeIndexInArrays(floorPlanFiles, floorPlanDisplayUrls);
    const floorPlanMaxIsReachedError = freeIndex === -1;

    this.setState({
      floorPlanMaxIsReachedError,
      floorPlanFiles: getCopyAndReplaceItemByIndex(freeIndex, floorPlanFiles, file),
    });
  }

  onClearFloorPlan(indexToReset) {
    const { floorPlanFiles, floorPlanDisplayUrls, deleteFloorPlanFiles } = this.state;

    this.setState({
      floorPlanFiles: getCopyAndReplaceItemByIndex(indexToReset, floorPlanFiles),
      floorPlanDisplayUrls: getCopyAndReplaceItemByIndex(indexToReset, floorPlanDisplayUrls),
      deleteFloorPlanFiles: getCopyAndReplaceItemByIndex(indexToReset, deleteFloorPlanFiles, true),
    });
  }

  onIsnPostData() {
    const { testId, reportLayout: layout } = this.state;

    this.setState((prevState) => ({
      isnDataPostedResult: {},
      isnDataPosting: !prevState.isnDataPosting,
    }));

    postReport(testId, layout)
      .then((result) => {
        this.setState((prevState) => ({
          isnDataPostedResult: result,
          isnDataPosting: !prevState.isnDataPosting,
        }));
      })
      .catch((error) => {
        let errorMessage =
          error.message ||
          'There was an error posting the report. Please retry later or contact your system administrator for assistance.';

        this.setState((prevState) => ({
          isnDataPostedResult: {
            message: errorMessage,
          },
          isnDataPosting: !prevState.isnDataPosting,
        }));

        notifyError(errorMessage);
      });
  }

  parseSeparatedEmails(emails) {
    if (!emails) return [];

    const emailArray = [];
    const contactEmail = emails.split(',');
    contactEmail.map((email) => {
      email = email.trim();
      emailArray.push({
        value: email,
        label: email,
        className: 'Select-create-option-placeholder',
      });
    });
    return emailArray;
  }

  renderStateSpecificNotes() {
    const { layout } = this.state;

    return <StateSpecificNotes value={layout ? layout.specificNote : null} />;
  }

  renderIntervalReport() {
    const {
      SerialNumber,
      AverageRadon,
      DeviceType,
      IsCompleted,
      UncertaintyCalculationResult
    } = this.state.values || {};
    const { deviceTypes, intervalReport, includeUncertaintyCalculation } = this.state;
    const { uom } = this.props.user;

    return (
      <Choose>
        <When condition={intervalReport}>
          <Row className="mt-4">
            <div className="mb-1 col-md-6 text-left">
              <h3 style={{ fontSize: 20, fontWeight: 'bold' }}>Test data</h3>
            </div>
            {IsCompleted === 'true' ? (
              <div className="mb-1 col-md-6">
                <div className="p-2 offset-md-5 col-md-7 border text-center">
                  <h3
                    style={{ fontSize: 25, fontWeight: 'bold' }}
                    className="mr-2"
                  >{`Average Radon ${getMDCAverageRadonValue(
                    { averageRadon: AverageRadon, deviceType: DeviceType },
                    uom,
                    deviceTypes,
                  )} ${SYSTEMS_OF_MEASURE[uom].radon}`}</h3>
                </div>
              </div>
            ) : null}
          </Row>
          <Row className="mt-2">
            <div className="col-md-6 text-left">
              <h5 style={{ fontSize: 16 }}>{SerialNumber}</h5>
            </div>
            {IsCompleted === 'true' && includeUncertaintyCalculation && UncertaintyCalculationResult ? (
              <div className="mb-1 col-md-6 text-right">
                <h3 style={{ fontSize: 16 }} className="mr-2">
                  {`Uncertainty ± ${UncertaintyCalculationResult} ${SYSTEMS_OF_MEASURE[uom].radon}`}
                </h3>
              </div>
            ) : null}
          </Row>
          <Row className="mt-3">
            <TestResultsTable
              results={intervalReport.data}
              showRadon={intervalReport.allowToShowRadon}
              showAlpha={intervalReport.allowToShowAlpha}
              showTemperature={intervalReport.allowToShowTemperature}
              showHumidity={intervalReport.allowToShowHumidity}
              showPressure={intervalReport.allowToShowPressure}
            />
          </Row>
        </When>
      </Choose>
    );
  }

  onChangeReportLayout(reportLayout) {
    this.setState({ reportLayout });
  }

  onChangeLayout(value) {
    this.setState({ layout: value, layoutId: value.id });
  }

  renderSelectLayout(editMode) {
    const { layout, layouts } = this.state;

    return (
      <SelectLayout
        layouts={layouts}
        selectedLayout={layout ? layout : null}
        editMode={editMode}
        onChange={(value) => {
          this.onChangeLayout(value);
        }}
      />
    );
  }

  renderExports() {
    const { testId, values, layoutId, reportLayout, reportLayoutOptions } = this.state;

    let defaultEmailCc = [];
    if (values) {
      defaultEmailCc = this.parseSeparatedEmails(values.BuyerEmail);
      defaultEmailCc = defaultEmailCc.concat(this.parseSeparatedEmails(values.InspectorEmail));
    }

    const disableOfficialReport = reportLayout === OFFICIAL_REPORT && this.isValidTest;
    const disableQCReport = reportLayout === QC_LAYOUT && this.hasQCErrors;

    return (
      <ExportTestCard
        testId={testId}
        defaultEmailTo={values ? this.parseSeparatedEmails(values.ClientEmail) : []}
        defaultEmailCc={defaultEmailCc}
        hasData={values.HasData === 'true'}
        isTestCompleted={values.IsCompleted === 'true'}
        layoutId={layoutId}
        disableOfficialReport={!disableOfficialReport}
        disableQCReport={disableQCReport}
        reportLayout={reportLayout}
        hasErrors={this.hasErrors}
        reportLayoutOptions={reportLayoutOptions}
        onChangeReportLayout={this.onChangeReportLayout}
      />
    );
  }

  renderIsnPost() {
    const { values, isDataCollecting, isnDataPosting, isnDataPostedResult, company, reportLayout } = this.state;
    const { user } = this.props;

    return (
      <IsnPostReport
        canEdit={false}
        test={{
          isIsn: values.IsIsn === 'true',
          isnAttachmentId: values.IsnAttachmentId,
          isnAttachmentDate: values.IsnAttachmentDate,
          isnTestDisplayOid: values.IsnTestDisplayOid,
          company: company,
        }}
        disabled={
          !reportLayout ||
          user.isSpruceAdmin ||
          (reportLayout === OFFICIAL_REPORT && this.isValidTest && this.hasErrors) ||
          (reportLayout === QC_LAYOUT && this.hasQCErrors)
        }
        onIsnPostData={this.onIsnPostData}
        isDataCollecting={isDataCollecting}
        isnDataPosting={isnDataPosting}
        isnDataPostedResult={isnDataPostedResult}
        tzAbbr={user.tzAbbr}
        hasData={values.HasData === 'true'}
        isTestCompleted={values.IsCompleted === 'true'}
        layout={reportLayout}
      />
    );
  }

  onQcFieldChange(name, value) {
    this.setState((prevState) => ({
      values: {
        ...prevState.values,
        [getDinamycTestName(name)]: value,
      },
    }));
  }

  onQcFieldValidate(name, error) {
    this.setState((prevState) => ({
      qcErrors: {
        ...prevState.qcErrors,
        [name]: error,
      },
    }));
  }

  hideErrorWindow() {
    this.setState({
      fileUploadError: false,
      floorPlanUploadError: false,
      filesMaxIsReachedError: false,
      floorPlanMaxIsReachedError: false,
    });
  }

  showImageErrorWindow() {
    this.setState({
      fileUploadError: true,
    });
  }

  showFloorPlanErrorWindow() {
    this.setState({
      floorPlanUploadError: true,
    });
  }

  onSwitchUom(toUom) {
    const { QcUnitOfMeasure, QcAveragePressure, QcAverageRadon, QcAverageTemperature } = this.state.values || {};

    const fromUom = SYSTEMS_OF_MEASURE[QcUnitOfMeasure || DEFAULT_UOM];
    const pressure = new Pressure(Number(QcAveragePressure || 0), fromUom.pressure);
    const radon = new Radon(Number(QcAverageRadon || 0), fromUom.radon);
    const temperature = new Temperature(Number(QcAverageTemperature || 0), fromUom.temperature);

    if (toUom === IMPERIAL) {
      this.onQcFieldChange('averagePressure', QcAveragePressure && pressure.toImperial().toFixed(2));
      this.onQcFieldChange('averageRadon', QcAverageRadon && radon.toImperial().toFixed(1));
      this.onQcFieldChange('averageTemperature', QcAverageTemperature && temperature.toImperial().toFixed(2));
    }

    if (toUom === METRIC) {
      this.onQcFieldChange('averagePressure', QcAveragePressure && pressure.toMetric().toFixed(2));
      this.onQcFieldChange('averageRadon', QcAverageRadon && radon.toMetric().toFixed());
      this.onQcFieldChange('averageTemperature', QcAverageTemperature && temperature.toMetric().toFixed(2));
    }

    this.onQcFieldChange('unitOfMeasure', toUom);
  }

  renderQcTestInfo() {
    const { values, qcErrors, showValidationErrors } = this.state;
    const { user } = this.props;

    const qc = {
      serialNumber: values.QcSerialNumber,
      seviceType: values.QcSeviceType,
      deviceModel: values.QcDeviceModel,
      unitOfMeasure: values.QcUnitOfMeasure,
      deviceType: values.QcDeviceType || null,
      averageRadon: values.QcAverageRadon,
      averageTemperature: values.QcAverageTemperature,
      averageHumidity: values.QcAverageHumidity,
      averagePressure: values.QcAveragePressure,
    };

    return (
      <QCTestInfo
        qc={qc}
        defaultUom={user.uom}
        onSwitchUom={this.onSwitchUom}
        editMode={this.editMode}
        onFieldChange={this.onQcFieldChange}
        onFieldValidate={this.onQcFieldValidate}
        errors={qcErrors}
        showErrors={showValidationErrors}
        qcDeviceTypes={QC_DEVICE_TYPE_OPTIONS}
      />
    );
  }

  get editButtons() {
    const { isSpruceAdmin } = this.props.user;
    return [
      <If condition={isSpruceAdmin} key="delete">
        {this.deleteButton}
      </If>,
      this.cancelButton,
      this.saveButton,
      this.viewButton,
    ];
  }

  get viewButtons() {
    return [this.cancelButton, this.editButton];
  }

  get viewButton() {
    return (
      <Link
        to={{
          pathname: `/dynamictests/${this.state.testId}`,
          state: { editMode: false },
        }}
        key="view"
      >
        <Button kind="primary">View Test</Button>
      </Link>
    );
  }

  get editButton() {
    return (
      <Link
        to={{
          pathname: `/dynamictests/${this.state.testId}`,
          state: { editMode: true },
        }}
        key="edit"
      >
        <Button kind="primary" className="mr-2">
          Edit Test
        </Button>
      </Link>
    );
  }

  get hasErrors() {
    const { errors } = this.state;

    return Object.values(errors).filter((value) => value).length > 0;
  }

  get hasQCErrors() {
    const { qcErrors } = this.state;

    return Object.values(qcErrors).filter((value) => value).length > 0;
  }

  get isValidTest() {
    const { values } = this.state;

    return values.IstestValid === 'Yes';
  }

  renderDeleteModal() {
    const { testId, showDeleteModal } = this.state;
    return (
      <ActionModal
        message={`Are you sure you want to delete test?`}
        isOpen={showDeleteModal}
        action={() => deleteTest(testId)}
        onCancel={this.toggleDeleteModal}
        onSuccess={() => this.props.history.push('/tests')}
        onError={() => notifyError()}
      />
    );
  }

  render() {
    const {
      layout,
      values,
      errors,
      images,
      testImagesBase64,
      floorPlanFiles,
      floorPlanDisplayUrls,
      isDataCollecting,
      company,
      fileUploadError,
      floorPlanUploadError,
      filesMaxIsReachedError,
      floorPlanMaxIsReachedError,
    } = this.state;

    const { user } = this.props;

    const header = this.editMode ? 'Edit Test' : 'View Test';
    const actions = this.editMode ? this.editButtons : this.viewButtons;
    const showIsnBox = (values && values.IsIsn) || (company && company.isIsn);

    const isTestNotValid = values.IstestValid && values.IstestValid === 'No';

    return (
      <Page header={header} breadCrumbs={this.getBreadCrumbs(header)} actions={actions}>
        <Container fluid className="px-0 mx-0">
          <Row>
            <Col lg={6}>
              {!!layout && (
                <Tabs key={layout.displayName} selectedTabClassName={styles.selectedTabs}>
                  <TabList className={styles.tabs_list}>
                    <HStack spacing={0}>
                      {!!layout.layout &&
                        layout.layout.map((groups) => (
                          <Tab key={groups.name} className={styles.tab}>
                            <img src={tabsImages[groups.name]} alt={groups.name} className={styles.tab_image} />
                            {groups.name}
                          </Tab>
                        ))}
                    </HStack>
                  </TabList>

                  <p className={styles.requiredNote}>
                    <RequiredAsterisk /> - Field must be completed to generate Official Report. For Invalid reports only
                    &laquo;Invalid Report Reason&raquo; field is required.
                  </p>

                  {!!layout.layout &&
                    layout.layout.map((groups) => (
                      <div key={groups.name}>
                        <TabPanel forceRender={true}>
                          {groups.groups.map((group) => {
                            return (
                              <div key={group.name}>
                                <div className={styles.subGroupName}>{group.name}</div>
                                <Row className="mb-4 text-left">
                                  <Col className={styles.dataBlock}>
                                    {group.widgets.map((widget) => {
                                      return DynamicRenderControls({
                                        component: widget,
                                        value: values,
                                        condition: this.editMode ? 'Edit' : 'View',
                                        isIsn: values.IsIsn,
                                        isLegacyDevice: checkLegacy(legacyDevices, values.DeviceType),
                                        onChange: this.onFieldChange,
                                        onValidate: this.onFieldValidate,
                                        editMode: getFieldEditMode(
                                          this.editMode,
                                          widget.id,
                                          values.IsDeviceCalibrationDate,
                                        ),
                                        errors,
                                        isSpruceAdmin: user.isSpruceAdmin,
                                        ifValue: typeof widget.child !== 'undefined' ? values[widget.child.id] : '',
                                        format: getFormat(widget.id, values.IsDeviceCalibrationDate),
                                        isTestNotValid,
                                      });
                                    })}
                                  </Col>
                                </Row>
                              </div>
                            );
                          })}
                        </TabPanel>
                      </div>
                    ))}
                </Tabs>
              )}
            </Col>
            <Col lg={6}>
              <VStack minH={'38px'}>
                <If condition={this.editMode}>
                  <QCToggle
                    onChange={(value) => this.onFieldChange('TestType', value)}
                    testType={values.TestType}
                    isDynamicTest={true}
                  />
                </If>
              </VStack>

              <If condition={values.TestType === TEST_TYPES.qc || values.TestType === TEST_TYPES.dinamicQc}>
                {this.renderQcTestInfo()}
              </If>
              {this.renderStateSpecificNotes()}
              {this.renderSelectLayout(this.editMode)}
              <If condition={!this.editMode}>{this.renderExports()}</If>
              <TestImages
                edit={this.editMode}
                imageDeleted={true}
                imageBase64={testImagesBase64}
                images={images}
                onLoad={this.onLoadImage}
                onClear={this.onClearImage}
                showErrorWindow={this.showImageErrorWindow}
                maxImages={this.maxImages}
              />
              <FloorPlan
                edit={this.editMode}
                files={floorPlanFiles}
                imagesUrls={floorPlanDisplayUrls}
                onLoad={this.onLoadFloorPlan}
                onClear={this.onClearFloorPlan}
                showErrorWindow={this.showFloorPlanErrorWindow}
              />
              <Choose>
                <When condition={this.editMode}>
                  <If condition={showIsnBox}>
                    <IsnIntegration
                      canEdit={false}
                      disabled={user.isSpruceAdmin}
                      test={{
                        isIsn: values.IsIsn === 'true',
                        isnTestDisplayOid: values.IsnTestDisplayOid,
                        company,
                      }}
                      onIsnGetData={this.onIsnGetData}
                      isDataCollecting={isDataCollecting}
                    />
                  </If>
                </When>
                <Otherwise>
                  <If condition={showIsnBox}>{this.renderIsnPost()}</If>
                </Otherwise>
              </Choose>
            </Col>
          </Row>
          {this.renderIntervalReport()}
          {this.renderDeleteModal()}
        </Container>

        <Modal
          isOpen={fileUploadError}
          showCancelButton={false}
          onConfirm={this.hideErrorWindow}
          header="Files upload error"
        >
          Files could not be uploaded. Make sure the each file has an image extension and its size less than 1Mb
        </Modal>
        <Modal
          isOpen={floorPlanUploadError}
          showCancelButton={false}
          onConfirm={this.hideErrorWindow}
          header="Floor Plan upload error"
        >
          The file could not be uploaded. Make sure the file has an image extension and its size less than 5Mb
        </Modal>
        <Modal
          isOpen={filesMaxIsReachedError}
          showCancelButton={false}
          onConfirm={this.hideErrorWindow}
          header="Maximum files are reached"
        >
          You can only upload a maximum of {this.maxImages} images per test.
        </Modal>
        <Modal
          isOpen={floorPlanMaxIsReachedError}
          showCancelButton={false}
          onConfirm={this.hideErrorWindow}
          header={`Only ${this.maxImages} files can be attached`}
        >
          To add a new floor plan, delete the existing one.
        </Modal>
      </Page>
    );
  }
}

DynamicTestDetailsPage.propTypes = propTypes;

const mapStateToProps = ({ profile }) => ({
  user: profile,
});

export default connect(mapStateToProps)(withEulaRestrictions(withRoleRestrictions(DynamicTestDetailsPage)));



// WEBPACK FOOTER //
// src/components/dynamicTestDetails/DynamicTestDetailsPage.jsx